<template>
    <div>
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">{{ $t("main-menu11") }}</span>
            </li>
        </ul>
        <main v-if="mobileCheck">
            <section class="slogan">
                <div class="main-title">{{ $t('home-title4') }}</div>
                <div class="main-subtitle">{{ $t('en-primeur2') }}</div>
                <div class="container1366 padding200">
                    <div class="why-vindome-wrapper">
                        <div class="why-vindome-col">
                            <div class="how-icon">
                                <div class="card-icon card-icon-tag"></div>
                                <div class="card-text">{{ $t('en-primeur3') }}</div>
                            </div>
                        </div>
                        <div class="why-vindome-col why-vindome-col-2">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="61.3335" width="10.6667" height="10.6667" fill="#907D4C"/>
                                        <rect x="25.7773" y="47.1113" width="10.6667" height="24.8889" fill="#907D4C"/>
                                        <rect x="43.5557" y="32.8887" width="10.6667" height="39.1111" fill="#907D4C"/>
                                        <rect x="61.333" y="8" width="10.6667" height="64" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-text">{{ $t('en-primeur4') }}</div>
                            </div>
                        </div>
                        <div class="why-vindome-col why-vindome-col-3">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M58.75 29.3333H55.625V23.2381C55.625 14.8267 48.625 8 40 8C31.375 8 24.375 14.8267 24.375 23.2381V29.3333H21.25C17.8125 29.3333 15 32.0762 15 35.4286V65.9048C15 69.2571 17.8125 72 21.25 72H58.75C62.1875 72 65 69.2571 65 65.9048V35.4286C65 32.0762 62.1875 29.3333 58.75 29.3333ZM40 56.7619C36.5625 56.7619 33.75 54.019 33.75 50.6667C33.75 47.3143 36.5625 44.5714 40 44.5714C43.4375 44.5714 46.25 47.3143 46.25 50.6667C46.25 54.019 43.4375 56.7619 40 56.7619ZM49.6875 29.3333H30.3125V23.2381C30.3125 18.0267 34.6562 13.7905 40 13.7905C45.3438 13.7905 49.6875 18.0267 49.6875 23.2381V29.3333Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-text">{{ $t('en-primeur5') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="home-tab-container">
                <div class="container home-collections-container">
                    <h2 v-if="popularEnWines.length" class="home-title home-title-live">
                        {{ $t('latest-offers') }}
                        <a href="/en-primeur" class="show-all-btn">{{ $t('see-all') }}</a>
                    </h2>
                    <div class="title-border"></div>
                    <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                    <nuxt-link :to="localePath('/trading-desk/EnPrimeur')" class="show-all-btn">{{ $t('see-all') }}</nuxt-link>
                </div>
            </div>
        </main>
        <main v-else>
            <section class="slogan">
                <div class="main-title">{{ $t('home-title4') }}</div>
                <div class="main-subtitle">{{ $t('en-primeur2') }}</div>
                <div class="container1366 padding200">
                    <div class="why-vindome-wrapper">
                        <v-row>
                            <v-col class="why-vindome-col">
                                <div class="how-icon">
                                    <div class="card-icon card-icon-tag"></div>
                                    <div class="card-text">{{ $t('en-primeur3') }}</div>
                                </div>
                            </v-col>
                            <v-col class="why-vindome-col why-vindome-col-2">
                                <div class="how-icon">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="8" y="61.3335" width="10.6667" height="10.6667" fill="#907D4C"/>
                                            <rect x="25.7773" y="47.1113" width="10.6667" height="24.8889" fill="#907D4C"/>
                                            <rect x="43.5557" y="32.8887" width="10.6667" height="39.1111" fill="#907D4C"/>
                                            <rect x="61.333" y="8" width="10.6667" height="64" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur4') }}</div>
                                </div>
                            </v-col>
                            <v-col class="why-vindome-col">
                                <div class="how-icon">
                                    <div class="card-icon">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M58.75 29.3333H55.625V23.2381C55.625 14.8267 48.625 8 40 8C31.375 8 24.375 14.8267 24.375 23.2381V29.3333H21.25C17.8125 29.3333 15 32.0762 15 35.4286V65.9048C15 69.2571 17.8125 72 21.25 72H58.75C62.1875 72 65 69.2571 65 65.9048V35.4286C65 32.0762 62.1875 29.3333 58.75 29.3333ZM40 56.7619C36.5625 56.7619 33.75 54.019 33.75 50.6667C33.75 47.3143 36.5625 44.5714 40 44.5714C43.4375 44.5714 46.25 47.3143 46.25 50.6667C46.25 54.019 43.4375 56.7619 40 56.7619ZM49.6875 29.3333H30.3125V23.2381C30.3125 18.0267 34.6562 13.7905 40 13.7905C45.3438 13.7905 49.6875 18.0267 49.6875 23.2381V29.3333Z" fill="#907D4C"/>
                                        </svg>
                                    </div>
                                    <div class="card-text">{{ $t('en-primeur5') }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </section>

            <section id="latest-offers">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('latest-offers') }}</h2>
                    <div class="title-border"></div>
                    <div class="latest-offers-wrapper">
                        <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                        <nuxt-link :to="localePath('/trading-desk/EnPrimeur')" class="show-all-btn">{{ $t('see-all') }}</nuxt-link>
                    </div>
                </div>
            </section>

            <section id="contact-us">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('contact-en-wines') }}</h2>
                    <div class="title-border"></div>
                    <div class="contactus-wrapper">
                        <div class="contact-text">{{ $t('contact-en-wines2') }}</div>
                        <div :class="$i18n.locale.toLowerCase() === 'de' ? 'show-contact-btn-de' : 'show-contact-btn'" v-on:click="showContactUs=true">{{ $t('contact0') }}</div>
                    </div>
                </div>
            </section>
        </main>

        <v-dialog content-class="contactus-dialog" v-model="showContactUs" persistent max-width="570px">
            <v-card class="contact-card">
                <v-card-title>
                    <div class="contactus-headline">Contact us to order En Primeur</div>
                    <div class="contactus-close" @click="showContactUs = false"></div>
                </v-card-title>
                <div class="contact-wrapper" v-if="!successMessage">
                    <v-flex>
                        <span class="login-label">{{ $t('contact1') }}</span>
                        <v-text-field
                            v-model="userName"
                            class="email-input"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-flex>

                    <v-flex>
                        <span class="login-label">{{ $t('contact2') }}</span>
                        <v-text-field
                            v-model="userEmail"
                            class="email-input"
                            :rules="[rules.required, rules.emailValid]"
                        ></v-text-field>
                    </v-flex>

                    <v-flex>
                        <span class="login-label">{{ $t('contact3') }}</span>
                        <v-textarea
                            class="contact-textarea"
                            :rules="[rules.required]"
                            v-model="notes"
                            rows="3"
                        ></v-textarea>
                    </v-flex>

                    <v-flex>
                        <div class="errors-container" v-if="errorMsg2 !== ''">
                            <p>{{errorMsg2}}</p>
                        </div>
                    </v-flex>

                    <v-btn class="submit-btn" text v-on:click="sendContact">{{ $t('contact4') }}</v-btn>
                </div>
                <div class="contact-wrapper success-wrapper" v-else>
                    <div class="success-info">{{ $t('contact6') }}</div>
                    <v-btn class="done-btn" text v-on:click="resetForm">{{ $t('contact7') }}</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {required, email, minLength} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from "vuex";
import WineMarketHome from "../components/WineMarketHome";
import HomePopularWines from "../components/home/HomePopularWines";
import {GCommon, GMarket, GUser} from "@/store/getters";
import {AAuth, AMarket, AOrders} from "@/store/actions";
import axios from "axios";
import 'vueperslides/dist/vueperslides.css'

export default {
    name: 'EnPrimeur',
    head: {
        title: 'En Primeur wine market | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'enprimeur-page'
        }
    },
    validations: {
        userEmail: {
            required,
            email
        },
        userEmail2: {
            required,
            email
        },
        userName: {
            required
        },
        notes: {
            required
        },
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    components: {
        WineMarketHome, HomePopularWines
    },
    data() {
        return {
            externalSource: '',
            isBrowser: false,
            show: false,
            showContactUs: false,
            popularWines: [],
            popularEnWines: [],
            selectedTab: 3,
            successMessage: false,
            successMessage2: false,
            successMessageEn: false,
            errorMsg: '',
            errorMsg2: '',
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.reg.test(value) || 'Invalid email'
            },
            userEmail: '',
            userEmail2: '',
            userName: '',
            notes: '',
            errorMsg3: '',
            nextStep: false,
            regEmail: '',
            regPassword: '',
            regFName: '',
            regLName: '',
            countryId: 224,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
        }
    },
    computed: {
        ...mapGetters({
            topWines: GMarket.GET_TOP_WINES,
            topEnWines: GMarket.GET_TOP_EN_WINES,
            wineItems: GMarket.GET_WINES,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED,
            userData : GUser.GET_USER_DATA
        }),
        popularWinesIds() {
            let _list = [];
            this.topWines.forEach(el => {
                _list.push(el.wineId + 'zzz' + el.caseSizeId)
            });
            return _list
        },
        popularEnWinesIds() {
            let _list = [];
            this.topEnWines.forEach(el => {
                _list.push(el.wineId)
            });
            return _list
        }
    },
    methods: {
        async sendContact () {
            if (this.userEmail && this.userName && this.notes && !this.$v.userEmail.$invalid) {
                this.errorMsg2 = '';
                let contactCtrl = this;
                let options = {
                    method: 'POST',
                    url: 'https://forms.raketa.cloud/submit/XXj4SzpmtB',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {
                        data: {
                            name: this.userName,
                            email: this.userEmail,
                            message: this.notes
                        }
                    }
                };
                let response = await axios(options);
                let responseOK = response && response.status === 200 && response.statusText === 'OK';
                if (responseOK) {
                    contactCtrl.successMessage = true
                }
            } else {
                this.errorMsg2 = 'Please fill all fields';
            }
        },
        closeEnPrimeurModal() {
            this.showEnPrimeur = false;
            this.successMessage2 = false;
        },
        goToRegister() {
            this.$router.push(this.localePath({path: '/register'}));
        },
        goToLogin() {
            localStorage.setItem('login_path', window.location.pathname);
            this.$router.push(this.localePath({path: '/login'}));
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        async sendContact2 () {
            if ((!this.isLogged && this.userEmail2 && !this.$v.userEmail2.$invalid) || this.isLogged) {
                this.errorMsg = '';
                let contactCtrl = this;
                let options = {
                    method: 'POST',
                    url: 'https://forms.raketa.cloud/submit/uVBlbFIcwV',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {
                        data: {
                            email: this.isLogged ? this.userData.email : this.userEmail2,
                            message: '*** En Primeur website pop up sign up ***'
                        }
                    }
                };
                let response = await axios(options);
                let responseOK = response && response.status === 200 && response.statusText === 'OK';
                if (responseOK) {
                    contactCtrl.successMessage2 = true
                }
            } else {
                this.errorMsg = 'Please fill all fields';
            }
        },
        resetForm () {
            this.userName = '';
            this.userEmail = '';
            this.notes = '';
            this.successMessage = false;
            this.showContactUs = false
        },
        registration() {
            let _ctrl = this;
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();

            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '+ 1',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };

                    this.signup(payload).then(res => {
                        if (res.statusCode === 400) {
                            this.isLoading = false;
                            this.errorMsg = 'Email is already in use.';
                        } else {
                            if (res.reasonPhrase === "Created") {
                                this.nextStep = true;
                            }

                            let options = {
                                method: 'POST',
                                url: 'https://forms.raketa.cloud/submit/NcDv6mP6me',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json;charset=UTF-8'
                                },
                                data: {
                                    data: {
                                        email: _ctrl.regEmail,
                                        message: "Amfora"
                                    }
                                }
                            };
                            axios(options);

                            this.$gtm.push({ event: "registration" });
                            window.fbq('track', 'CompleteRegistration');
                            window.uetq = window.uetq || [];
                            window.uetq.push("event", "signup", {});
                            this.$gtm.push({
                                'event': 'UETRegistration',
                                'ecomm_pagetype': 'conversion'
                            });
                        }
                    }).catch(err => {
                        this.isLoading = false;
                        if (err.status === 400) {
                            this.errorMsg = 'Email is already in use.';
                        } else {
                            this.errorMsg = 'Please try again.';
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }
        },
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL
        })
    },
    mounted (){
        this.isBrowser = process.browser
        this.$store.dispatch(AMarket.GET_TOP_WINES);
        this.externalSource = this.$route.query.source

        this.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
            let homeCtrl = this,
                addedWines = 0;

            if (this.wineItems.length) {
                this.wineItems.forEach(wine => {
                    if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                        homeCtrl.popularEnWines.push(wine);
                        addedWines++
                    }
                })
            } else {
                setTimeout(() => {
                    this.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                            homeCtrl.popularEnWines.push(wine);
                            addedWines++
                        }
                    })
                }, 1000)
            }

        });

        this.$store.dispatch(AMarket.GET_HOME_WINES).then(() => {
            let homeCtrl = this;
            this.wineItems.forEach(wine => {
                if (homeCtrl.popularWinesIds.indexOf(wine.wineId + 'zzz' + wine.caseSizeId) > -1) {
                    homeCtrl.popularWines.push(wine)
                }
            })
        });
    }
};
</script>

<style scoped>
.card-back {
    background: url("../assets/en_primeur_2024.jpg") no-repeat center;
    background-size: cover;
    width: 245px;
    height: 397px;
    display: inline-block;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 16px !important;
}
.enprimeur-dialog2 .card-back {
    height: 630px;
}
.why-vindome-wrapper {
    margin-top: 40px;
}
.how-icon {
    height: 236px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 4px 16px rgba(117, 102, 62, 0.5);
    border-radius: 16px;
    padding: 16px;
}
.why-vindome-col {
    width: calc((100% - 48px) / 3);
}
.why-vindome-col-2 {
    margin: 0 24px;
}
.errors-container {
    padding-left: 10px;
}
.card-icon-tag {
    background: url("../assets/landing/tag-svg.svg") no-repeat center;
    background-size: 65px;
}
.card-icon {
    height: 80px;
    width: 80px;
    margin: 0 auto 8px;
}
.card-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 16px;
    font-weight: 700;
    color: #303030;
    text-align: center;
    text-transform: uppercase;
}
.card-text {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #002840;
    text-align: center;
}
.enprimeur-page {
    font-size: 14px;
    background-color: #fff;
    color: #000;
}

.enprimeur-page ul {
    padding-left: 0;
}

.container {
    position: relative;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.padding200 {
    padding: 0 200px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}
.title-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 40px;
}

.hidden {
    display: none;
}

/* reset */

body, div, dl, dt, dd, ul, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, input, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
}

table {
    border-spacing: 0;
    border-collapse: collapse;
}

fieldset, img, abbr {
    border: 0;
}

address, caption, cite, code, dfn, em, th, var {
    font-weight: normal;
    font-style: normal;
}

ul li {
    list-style: none;
}

caption, th {
    text-align: left;
}

button {
    border: none;
    background: none;
}

button:hover {
    cursor: pointer;
}

a {
    text-decoration: none;
}

/* slogan section */

.slogan {
    height: 600px;
    position: relative;
    background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0) 100%), url('../assets/redesign/en_primeur.png') no-repeat center;
    background-size: cover;
    padding-top: 80px;
}

.main-title {
    color: #ffffff;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    padding: 60px 0 24px 0;
    text-transform: capitalize;
    text-align: center;
}
.main-subtitle {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #FFFFFF;
    max-width: 918px;
    margin: 0 auto;
}

/* START Top Collections */
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    margin-bottom: 24px;
    position: relative;
    text-align: center;
}

.show-all-btn {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 120px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    display: block;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
}

.home-collections-container {
    max-width: 1214px;
    margin: 0 auto;
}

/* END Top Collections */

.home-title-live {
    margin-top: 50px;
}

.show-contact-btn {
    padding: 8px 16px;
    width: 105px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 8px;
    display: block;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 19px;
    color: #004F7F;
    text-align: center;
    margin: 16px auto 0;
}
.show-contact-btn-de {
    padding: 8px 16px;
    width: 170px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 8px;
    display: block;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 19px;
    color: #004F7F;
    text-align: center;
    margin: 16px auto 0;
}
.show-contact-btn:hover,
.show-contact-btn-de:hover {
    cursor: pointer;
}
.contact-text {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
}
.contactus-headline {
    color: #303030;
    width: 300px;
    margin: 0 auto;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: rgba(0, 0, 0, 0.88);
}
.home-more-collections {
    margin-bottom: 19px;
}
.home-title-coming-soon {
    text-align: center;
    margin: 150px auto;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 25px;
    line-height: 30px;
    font-weight: 700;
}
.contact-wrapper {
    background: #F6F6F6;
    border-radius: 8px;
    padding: 27px 56px 32px 32px;
    margin: 16px auto;
    width: 440px;
}
.enprimeur-wrapper {
    width: calc(100% - 249px);
    vertical-align: top;
    display: inline-block;
    padding: 32px 20px;
}
html[lang=de] .enprimeur-wrapper {
    padding: 28px 12px;
}
.enprimeur-info {
    color: #002840;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 8px;
}
.enprimeur-info-text {
    color: #002840;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.enprimeur-info-text p {
    margin-bottom: 10px;
}
.enprimeur-dialog2 .enprimeur-info-text p {
    text-align: left;
}
.submit-btn {
    background: #E1C376 !important;
    color: #FFF !important;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    box-shadow: none;
    margin: 15px auto 0;
    display: block;
}
.submit-btn2 {
    border-radius: 8px;
    background: #004F7F;
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    box-shadow: none;
    margin: 24px auto 0;
    display: block;
}
.submit-btn2-2 {
    border-radius: 8px;
    background: #004F7F;
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    box-shadow: none;
    margin: 16px auto 0;
    display: block;
}
.submit-btn3 {
    border-radius: 8px;
    background: transparent;
    border: 2px solid #004F7F;
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    box-shadow: none;
    margin: 8px auto 0;
    display: block;
}
.ok-btn {
    border-radius: 8px;
    background: #004F7F;
    height: 40px;
    padding: 8px 16px;
    box-shadow: none;
    margin: 24px auto 0;
    display: block;
    width: 102px;
}
.success-wrapper {
    text-align: center;
    background: url('../assets/success_icon.png') no-repeat center 30px;
    padding: 140px 32px 0;
}
.success-wrapper2 {
    background: url("../assets/how/ok.gif") no-repeat center top;
    background-size: 180px;
    margin: 0 auto;
    width: 100%;
    padding: 180px 40px 40px;
}
.success-wrapper2 h2 {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.88);
    margin: 24px auto;
}
.success-info {
    color: #303030;
}
.done-btn {
    background: #E1C376 !important;
    color: #FFF !important;
    margin-top: 30px;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
}
.contactus-close {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 24px;
    height: 24px;
    background: url("../assets/icon-close.svg") no-repeat center;
}
.contactus-close:hover {
    cursor: pointer;
}
#latest-offers {
    background-color: #F7F7F7;
}
.latest-offers-wrapper {
    margin-top: 16px;
}
#contact-us {
    width: 100%;
    height: 327px;
    background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
}
#contact-us .home-title {
    color: #ffffff;
}
.contactus-wrapper {
    text-align: center;
    color: #ffffff;
}
.login-success {
    text-align: center;
    background: url('../assets/success_icon.png') no-repeat center 30px;
    padding: 140px 32px 0;
    margin-top: 100px;
}
.login-success-btn-wrapper {
    margin-top: 40px;
    text-align: center;
}
.login-success-btn-wrapper .btn-bid-proceed.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background-color: var(--brand);
    color: #ffffff;
    min-width: 150px;
    margin-right: 6px;
}
.login-success-btn-wrapper .btn-bid-cancel.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}
.check-terms {
    margin-top: 6px;
}
.check-terms2 {
    margin-top: 16px;
}
.login-label {
    position: absolute;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 10px;
    color: #000000;
}

.login-inner-container  .login-label {
    font-size: 13px;
}

@media(max-width: 767px) {
    .home-title {
        font-size: 17px;
        line-height: 17px;
        font-weight: 700;
    }
    .contact-wrapper {
        padding: 25px;
        width: 100%;
    }
    .collections-h1 {
        font-size: 30px;
    }
    .home-title-live .show-all-btn {
        display: none;
    }
    .show-all-btn {
        margin-bottom: 32px;
        margin-top: 8px;
    }
    .main-title {
        padding-top: 44px;
        font-size: 18px;
        line-height: 22px;
    }
    .main-subtitle {
        font-size: 16px;
        line-height: 20px;
        padding: 0 16px;
    }
    .slogan {
        height: 100%;
    }
    .why-vindome-wrapper {
        margin-top: 24px;
        padding-bottom: 32px;
    }
    .why-vindome-col {
        width: 100%;
    }
    .why-vindome-col-2 {
        margin: 24px 0;
    }
    .why-vindome-col .how-icon {
        height: 212px;
    }
    .padding200 {
        padding: 0 16px;
    }
    .title-border {
        margin-bottom: 24px;
    }
    .home-collections-container {
        padding: 0;
    }
    .card-back {
        width: 100%;
        height: 200px;
        border-bottom-left-radius: 0 !important;
    }
    .enprimeur-dialog2 .card-back {
        width: 100%;
        height: 115px;
        border-bottom-left-radius: 0 !important;
    }
    .enprimeur-wrapper {
        width: 100%;
    }
    .enprimeur-dialog2 .theme--light.v-card.enprimeur-card {
        height: auto;
    }
}
</style>

<style>
.contactus-dialog {
    background: #ffffff;
}
.enprimeur-page .theme--light.v-card.contact-card {
    box-shadow: none;
    padding-top: 0;
    transition: none;
    background: #fff;
}
.enprimeur-dialog.v-dialog {
    height: 397px;
    box-shadow: none;
    border-radius: 16px;
}
.enprimeur-dialog2.v-dialog {
    height: 630px;
    box-shadow: none;
    border-radius: 16px;
}
.theme--light.v-card.enprimeur-card {
    box-shadow: none;
    border-radius: 16px;
    transition: none;
    background: #fff;
    height: 397px;
    overflow: hidden;
}
.enprimeur-dialog2 .theme--light.v-card.enprimeur-card {
    height: 630px;
}
@media (max-width: 767px) {
    .theme--light.v-card.enprimeur-card,
    .enprimeur-dialog.v-dialog,
    .enprimeur-dialog2.v-dialog {
        height: auto;
    }
}
.theme--light.v-card.enprimeur-card.enprimeur-card-success {
    background: #f4f4f4;
    padding: 40px;
}
.enprimeur-page .home-tab-container .theme--light.v-tabs .v-tabs-bar {
    display: none;
}

.v-slide-group__wrapper {
    max-width: 640px;
    margin: 0 auto;
}
.trading-desk .v-slide-group__wrapper {
    margin: 0
}
.home-tab-container .v-slide-group__content {
    justify-content: center;
}
.home-tab-container .v-tab {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    color: #000 !important;
    font-size: 16px;
    text-transform: none;
    line-height: 23px;
    letter-spacing: inherit;
}
.home-tab-container .v-tabs-slider-wrapper {
    height: 6px !important;
    color: #E2C477 !important;
    caret-color: #E2C477 !important;
}

.swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    height: 300px;
    width: 100%;
}
.show-mobile .swiper-container {
    height: 360px;
}
.people-notice-wrapper .swiper-container {
    height: 430px;
    margin-bottom: 50px;
}
.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform;
    box-sizing: content-box;
}

.swiper-container-no-flexbox .swiper-slide {
    float: left
}

.swiper-container-vertical>.swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform;
    box-sizing: content-box
}

.swiper-container-android .swiper-slide,.swiper-wrapper {
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.swiper-container-multirow>.swiper-wrapper {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.swiper-container-free-mode>.swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto
}

.swiper-slide {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform,-webkit-transform
}

.swiper-invisible-blank-slide {
    visibility: hidden
}

.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
    height: auto
}

.swiper-container-autoheight .swiper-wrapper {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    transition-property: height,-webkit-transform;
    transition-property: transform,height;
    transition-property: transform,height,-webkit-transform
}

.swiper-container-3d {
    -webkit-perspective: 1200px;
    perspective: 1200px
}

.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
}

.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10
}

.swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
}

.swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
    -ms-touch-action: pan-y;
    touch-action: pan-y
}

.swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
    -ms-touch-action: pan-x;
    touch-action: pan-x
}

.swiper-button-next,.swiper-button-prev {
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: 50%;
    background-repeat: no-repeat
}

.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
    opacity: .35;
    cursor: auto;
    pointer-events: none
}

.swiper-button-prev,.swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
    left: 50px;
    right: auto
}

.swiper-button-next,.swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
    right: 50px;
    left: auto
}

.swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transition: opacity .3s;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 10
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0
}

.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%
}

.carousel-wrapper {
    height: 480px;
    position: relative;
}

@media (max-width: 767px) {
    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 0;
    }
}

.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    -webkit-transform: scale(.33);
    transform: scale(.33);
    position: relative
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: .2
}

button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff
}

.swiper-container-vertical>.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    -webkit-transform: translate3d(0,-50%,0);
    transform: translate3d(0,-50%,0)
}

.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 6px 0;
    display: block
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 8px
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    display: inline-block;
    transition: top .2s,-webkit-transform .2s;
    transition: transform .2s,top .2s;
    transition: transform .2s,top .2s,-webkit-transform .2s
}

.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: left .2s,-webkit-transform .2s;
    transition: transform .2s,left .2s;
    transition: transform .2s,left .2s,-webkit-transform .2s
}

.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: right .2s,-webkit-transform .2s;
    transition: transform .2s,right .2s;
    transition: transform .2s,right .2s,-webkit-transform .2s
}

.swiper-pagination-progressbar {
    background: rgba(0,0,0,.25);
    position: absolute
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #007aff;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    transform-origin: left top
}

.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    -webkit-transform-origin: right top;
    transform-origin: right top
}

.swiper-container-horizontal>.swiper-pagination-progressbar {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0
}

.swiper-container-vertical>.swiper-pagination-progressbar {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0
}

.swiper-pagination-white .swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination-progressbar.swiper-pagination-white {
    background: hsla(0,0%,100%,.25)
}

.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
    background: #fff
}

.swiper-pagination-black .swiper-pagination-bullet-active {
    background: #000
}

.swiper-pagination-progressbar.swiper-pagination-black {
    background: rgba(0,0,0,.25)
}

.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
    background: #000
}

.swiper-scrollbar {
    border-radius: 10px;
    position: relative;
    -ms-touch-action: none;
    background: rgba(0,0,0,.1)
}

.swiper-container-horizontal>.swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%
}

.swiper-container-vertical>.swiper-scrollbar {
    position: absolute;
    right: 3px;
    top: 1%;
    z-index: 50;
    width: 5px;
    height: 98%
}

.swiper-scrollbar-drag {
    height: 100%;
    width: 100%;
    position: relative;
    background: rgba(0,0,0,.5);
    border-radius: 10px;
    left: 0;
    top: 0
}

.swiper-scrollbar-cursor-drag {
    cursor: move
}

.swiper-zoom-container {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center
}

.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain
}

.swiper-slide-zoomed {
    cursor: move
}

.swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    -webkit-transform-origin: 50%;
    transform-origin: 50%;
    -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
    animation: swiper-preloader-spin 1s steps(12) infinite
}

.swiper-lazy-preloader:after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
    background-position: 50%;
    background-size: 100%;
    background-repeat: no-repeat
}

.swiper-lazy-preloader-white:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
}

@-webkit-keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

.swiper-container .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
    transition-timing-function: ease-out
}

.swiper-container-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity
}

.swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube {
    overflow: visible
}

.swiper-container-cube .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 100%;
    height: 100%
}

.swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0
}

.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
    pointer-events: auto;
    visibility: visible
}

.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .6;
    -webkit-filter: blur(50px);
    filter: blur(50px);
    z-index: 0
}

.swiper-container-flip {
    overflow: visible
}

.swiper-container-flip .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1
}

.swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-coverflow .swiper-wrapper {
    -ms-perspective: 1200px
}

.enprimeur-page .contact-wrapper .flex {
    margin-top: 20px;
    text-align: left;
}
.enprimeur-page .contact-wrapper textarea {
    background: #ffffff;
    margin-top: 20px;
}
.enprimeur-page .contact-wrapper .v-input input,
.enprimeur-page .enprimeur-wrapper .v-input input {
    height: 40px;
    max-height: unset;
    margin-top: 20px;
    padding-left: 15px;
}
.enprimeur-page .contact-wrapper .v-text-field .v-input__append-inner,
.enprimeur-page .enprimeur-wrapper .v-text-field .v-input__append-inner {
    margin-top: 20px;
    background: #fff;
    height: 40px;
}
.enprimeur-page .contact-wrapper .v-text-field .v-input__append-inner .v-input__icon,
.enprimeur-page .enprimeur-wrapper .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 12px;
}
.enprimeur-page .contact-wrapper .v-text-field .v-input__append-inner .primary--text,
.enprimeur-page .enprimeur-wrapper .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}
.enprimeur-page .contact-wrapper .theme--light.v-input:not(.v-input--is-disabled) input,
.enprimeur-page .enprimeur-wrapper .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}
.enprimeur-page .contact-wrapper .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before,
.enprimeur-page .enprimeur-wrapper .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
    border-color: var(--brand);
}
.enprimeur-page .contact-wrapper .theme--light.v-text-field>.v-input__control>.v-input__slot:after,
.enprimeur-page .enprimeur-wrapper .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
    border-color: rgba(0,0,0,.87);
    border-width: 1px;
}
.enprimeur-page .contact-wrapper .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after,
.enprimeur-page .enprimeur-wrapper .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
    border-color: #ff5252;
}
.enprimeur-page .v-main {
    padding-top: 0 !important;
}
.enprimeur-page .swiper-container {
    height: 390px
}

.submit-btn2 .v-btn__content,
.submit-btn2-2 .v-btn__content{
    color: #FFF !important;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: 0;
    font-weight: 700;
    text-transform: none;
}
.submit-btn3 .v-btn__content {
    color: #004F7F !important;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: 0;
    font-weight: 700;
    text-transform: none;
}
.ok-btn .v-btn__content {
    color: #FFF !important;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: 0;
    font-weight: 700;
    text-transform: none;
}

.enprimeur-page .login-inner-container .v-text-field {
    padding-top: 12px;
    margin-top: 4px;
}
.enprimeur-page .flex {
    margin-top: 15px;
    text-align: left;
    position: relative;
}
.enprimeur-page .v-text-field__details {
    bottom: -7px;
    position: absolute;
}
.enprimeur-page .v-input input {
    height: 40px;
    max-height: unset;
    margin-top: 4px;
    padding-left: 15px;
}
.enprimeur-page .v-text-field .v-input__append-inner {
    margin-top: 4px;
    background: #fff;
    height: 40px;
}
.enprimeur-page .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 8px;
    margin-right: 3px;
}
.enprimeur-page .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}
.enprimeur-page .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}
.enprimeur-page .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
    border-color: var(--brand);
}
.enprimeur-page .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
    border-color: rgba(0,0,0,.87);
    border-width: 1px;
}
.enprimeur-page .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
    border-color: #ff5252;
}

.enprimeur-page .login-inner-container .flex {
    margin-top: 10px;
}

.enprimeur-page .login-inner-container .v-input input {
    height: 20px;
    max-height: none;
    max-height: initial;
    margin-top: 5px;
    padding-left: 15px;
    padding-top: 0;
    padding-bottom: 0;
}

.enprimeur-page .login-inner-container .v-text-field .v-input__append-inner {
    margin-top: -11px;
    background: #fff;
    height: 25px;
}

.login-inner-container .check-terms2 {
    margin-top: 5px;
}

.login-inner-container .v-label {
    font-size: 13px;
}

.check-terms .theme--light.v-messages {
    display: none;
}

@media (max-width: 767px) {
    .enprimeur-page .mobile-popular-wines {
        padding-bottom: 16px;
    }
}
</style>
